/** @format */

import moment from 'moment';
import { selectorBookingAvailability } from '../../@ducks/booking/selectors';

export const utilityIsRoomAvailableFrom = (availability: ReturnType<typeof selectorBookingAvailability>): boolean => {
  if (!availability) return false;
  return moment(availability.availableFrom).isAfter(moment().add(3, 'days'));
};
